/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilitySourceDetails extends models.KnownExploitedVulnerability {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilitySourceDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilitySourceDetails>): AppSecopsVulnerabilitySourceDetails {
        let obj = Object.assign(new AppSecopsVulnerabilitySourceDetails(), model);
        AppSecopsVulnerabilitySourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilitySourceDetails>): AppSecopsVulnerabilitySourceDetails {
        if (!model) return null;
        return AppSecopsVulnerabilitySourceDetails.newInstance(<AppSecopsVulnerabilitySourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilitySourceDetails) {
        if (!obj) return;

        models.AppSecopsVulnerabilitySourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilitySourceDetails): boolean {
        if (models.KnownExploitedVulnerability.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilitySourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.source_updated_at === "string") {
            this.source_updated_at = new Date(<string><any>this.source_updated_at);
        }
        if (typeof this.modified === "string") {
            this.modified = new Date(<string><any>this.modified);
        }
        if (typeof this.published === "string") {
            this.published = new Date(<string><any>this.published);
        }
        if (typeof this.lastModified === "string") {
            this.lastModified = new Date(<string><any>this.lastModified);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.advisories) {
            for (let val of this.advisories) {
                models.AppSecopsExternalReferenceDetail.fixupPrototype(val);
            }
        }
        if (this.affected) {
            for (let val of this.affected) {
                models.AppSecopsOsvVulnerabilityAffectedDetails.fixupPrototype(val);
            }
        }
        if (this.references) {
            for (let val of this.references) {
                models.AppSecopsExternalReferenceDetail.fixupPrototype(val);
            }
        }
        if (this.vendorComments) {
            for (let val of this.vendorComments) {
                models.AppSecopsVulnerabilityVendorComment.fixupPrototype(val);
            }
        }
        if (this.descriptions) {
            for (let val of this.descriptions) {
                models.VulnerabilityNvdDescription.fixupPrototype(val);
            }
        }
    }

    advisories: Array<models.AppSecopsExternalReferenceDetail>;

    affected: Array<models.AppSecopsOsvVulnerabilityAffectedDetails>;

    /**
     * Common Platform Enumeration(CPE) of the vulnerability
     */
    cpe: Array<string>;

    /**
     * Detailed information about the vulnerability
     */
    details: string;

    /**
     * Description of the vulnerability
     */
    description: string;

    references: Array<models.AppSecopsExternalReferenceDetail>;

    /**
     * Source of the vulnerability
     */
    source: models.VulnerabilitySource;

    /**
     * Origin of the vulnerability
     */
    origin: string;

    /**
     * List of related vulnerability CVE IDs
     */
    related: Array<string>;

    /**
     * Recommendation of the vulnerability
     */
    recommendation: string;

    /**
     * Vulnerability source URL
     */
    url: string;

    /**
     * Schema version of the vulnerability
     */
    schema_version: string;

    /**
     * Date when the source details was last updated
     */
    source_updated_at: Date;

    /**
     * Source identifier of the vulnerability
     */
    sourceIdentifier: string;

    /**
     * Summary of the vulnerability
     */
    summary: string;

    /**
     * Date when the source details was modified
     */
    modified: Date;

    /**
     * Date when the source details was published
     */
    published: Date;

    /**
     * Status of the vulnerability
     */
    vulnStatus: string;

    vendorComments: Array<models.AppSecopsVulnerabilityVendorComment>;

    descriptions: Array<models.VulnerabilityNvdDescription>;

    /**
     * Date when the source details was last modified
     */
    lastModified: Date;

    /**
     * List of upstream vulnerability IDs that are transitively referred to by this vulnerability entry
     */
    upstream: Array<string>;

    /**
     * Date when the vulnerability was last updated
     */
    updated_at: Date;

}
